import { useEffect, useState } from 'react'

const breakpoints = {
	sm: 640,
	md: 768,
	lg: 1024,
	xl: 1280,
	'2xl': 1536,
} as const

type Breakpoint = keyof typeof breakpoints

export function useBreakpoint() {
	const [currentBreakpoint, setCurrentBreakpoint] = useState<Breakpoint>('sm')

	useEffect(() => {
		const getBreakpoint = (): Breakpoint => {
			const width = window.innerWidth
			if (width >= breakpoints['2xl']) return '2xl'
			if (width >= breakpoints.xl) return 'xl'
			if (width >= breakpoints.lg) return 'lg'
			if (width >= breakpoints.md) return 'md'
			return 'sm'
		}

		const handleResize = () => {
			setCurrentBreakpoint(getBreakpoint())
		}

		// Set initial breakpoint
		handleResize()

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	const isAbove = (breakpoint: Breakpoint) => {
		if (typeof window === 'undefined') return false
		const currentWidth = window.innerWidth
		return currentWidth >= breakpoints[breakpoint]
	}

	const isBelow = (breakpoint: Breakpoint) => {
		if (typeof window === 'undefined') return true
		const currentWidth = window.innerWidth
		return currentWidth < breakpoints[breakpoint]
	}

	const isExactly = (breakpoint: Breakpoint) => {
		return currentBreakpoint === breakpoint
	}

	return {
		currentBreakpoint,
		isAbove,
		isBelow,
		isExactly,
		isMobile: currentBreakpoint === 'sm',
		isTablet: currentBreakpoint === 'md' || currentBreakpoint === 'lg',
		isDesktop: currentBreakpoint === 'xl' || currentBreakpoint === '2xl',
	}
}
